export default __webpack_public_path__ + "static/media/UncheckedRadioImage.f5c17cc5.svg";